import t from "vue";
export { default as Vue } from "vue";

function n(t, n) {
  var r = {};

  for (var e in t) {
    Object.prototype.hasOwnProperty.call(t, e) && -1 === n.indexOf(e) && (r[e] = t[e]);
  }

  return r;
}

var r = !0,
    e = !1,
    s = t,
    o = t.version,
    a = function a(t) {
  return function (r, e) {
    void 0 === e && (e = {});

    for (var s = [], o = arguments.length - 2; o-- > 0;) {
      s[o] = arguments[o + 2];
    }

    var a = e.className,
        i = n(e, ["className"]);
    if ("function" == typeof r) return r(Object.assign(i, {
      class: a || i.class,
      children: s.length > 0 ? s : void 0
    }));

    if ("string" == typeof r) {
      var c = i.on,
          l = i.style,
          u = i.attrs,
          f = i.domProps,
          v = i.nativeOn,
          p = i.key,
          d = n(i, ["on", "style", "attrs", "domProps", "nativeOn", "key"]);
      return t(r, {
        class: a || i.class,
        attrs: u || d,
        on: c,
        nativeOn: v,
        style: l,
        domProps: f,
        key: p
      }, s);
    }

    return t(r, Object.assign(i, {
      class: a || i.class
    }), s);
  };
};

function i(t) {
  return function (n) {
    return t.call(this, a(n));
  };
}

function c(t) {
  return t.$slots.default;
}

function l(t, n) {
  return (t.$scopedSlots || {})[n];
}

export { s as Vue2, c as getDefaultSlot, l as getScopedSlot, r as isVue2, e as isVue3, i as renderCompat, o as version };